export default "__VITE_ASSET__CYXR_Btc__"